/**
 * Profile-tab custom fields: keep social / general fields, drop mock-only
 * “Specializes in” / “The tank” style content when Console labels match.
 */
const EXCLUDE_KEY_OR_LABEL = /specializ|specialty|specialises|tank/i;

/**
 * @param {string} key
 * @param {string} [label]
 * @returns {boolean}
 */
export const isProfileTabUserField = (key, label = '') => {
  if (!key) {
    return false;
  }
  return !EXCLUDE_KEY_OR_LABEL.test(key) && !EXCLUDE_KEY_OR_LABEL.test(label || '');
};
